import React from 'react'
import {
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
  Typography,
} from '@mui/material'
import { colorPalette } from '../../../../style/colorPalette'

interface Props {
  value: string | undefined
  options: {
    value: string
    label: string
    iconUrl?: string
    /** 選択した場合の副作用などをホバー時に予告する */
    tooltip?: string
  }[]
  onChange: (value: string) => void
  disabled?: boolean
  height?: number
}

const ExclusiveToggleGroup: React.FC<Props> = (props: Props) => {
  const { value, options, onChange, disabled } = props
  const onChangeValue = (newValue: string | null) => {
    if (!newValue) {
      return
    }
    onChange(newValue)
  }
  const height = props.height || 24
  return (
    <ToggleButtonGroup
      value={value}
      onChange={(e, v) => onChangeValue(v)}
      exclusive={true}
      style={{
        border: `1px solid ${colorPalette.monotone[2]}`,
        width: 'fit-content',
        margin: '0 3px',
        background: colorPalette.monotone[0],
      }}
    >
      {options.map(option => {
        const button = (
          <ToggleButton
            size="small"
            key={`toggle-${option.value}`}
            value={option.value}
            sx={{
              textTransform: 'none',
              height,
              borderRadius: '4px !important',
              margin: '2px',
              border: 'none !important',
              color:
                option.value === value
                  ? `${colorPalette.monotone[0]} !important`
                  : colorPalette.monotone[4],
              background:
                option.value === value && !disabled
                  ? `${colorPalette.skyBlue[7]} !important`
                  : `${colorPalette.monotone[0]} 0% 0% no-repeat padding-box !important`,
              width: '100%',
              // ButtonBase は disabled 時に pointer-events: none を当てるため、
              // そのままだと Tooltip がホバーを拾えない
              ...(option.tooltip && {
                '&.Mui-disabled': { pointerEvents: 'auto' },
              }),
            }}
            disabled={disabled}
          >
            {option.iconUrl && (
              <img
                src={option.iconUrl}
                style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
              />
            )}
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                color: disabled ? colorPalette.monotone[2] : '',
              }}
            >
              {option.label}
            </Typography>
          </ToggleButton>
        )
        if (!option.tooltip) return button
        return (
          <Tooltip
            key={`toggle-tooltip-${option.value}`}
            title={option.tooltip}
            placement="top"
            arrow={true}
            slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line' } } }}
          >
            {button}
          </Tooltip>
        )
      })}
    </ToggleButtonGroup>
  )
}

export default ExclusiveToggleGroup
